import type {ApiWorkforceProfileRecord} from '../WorkforceProfiles/workforceProfileApiTypes';

import type {WorkforceProfileHighlights} from '../../types/WorkforceProfileTypes';


export const mapHighlights = (
  digest: ApiWorkforceProfileRecord | undefined
): WorkforceProfileHighlights | undefined => {
  if (!digest) {
    return undefined;
  }

  const strong = digest.strongAlignment;
  const gaps = digest.partialGaps;
  const strengths = digest.potentialStrengths;

  if (!Array.isArray(strong) && !Array.isArray(gaps) && !Array.isArray(strengths)) {
    return undefined;
  }

  return {
    strong: Array.isArray(strong) ? (strong as string[]) : [],
    gaps: Array.isArray(gaps) ? (gaps as string[]) : [],
    strengths: Array.isArray(strengths) ? (strengths as string[]) : [],
  };
};
